import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routerPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
const login = () =>
  import( /* webpackChunkName: "group_Index" */ '@/view/login')
const route = () =>
  import( /* webpackChunkName: "group_Index" */ '@/view/route')
const shopMgm = () =>
  import( /* webpackChunkName: "group_Index" */ '@/view/shopMgm')
const replyPolicy = () =>
  import( /* webpackChunkName: "group_Index" */ '@/view/replyPolicy')
const kamiList = () =>
  import( /* webpackChunkName: "group_Index" */ '@/view/kamiList')
const exam = () =>
  import( /* webpackChunkName: "group_Index" */ '@/view/exam')
const user = () =>
  import( /* webpackChunkName: "group_Index" */ '@/view/user')

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'login',
    component: login,
    meta: {
      title: "登录-小迪客服助手"
    }
  },
  {
    path: '/route',
    name: 'route',
    component: route,
    redirect: {
      name: 'shopMgm'
    },
    children: [{
      path: '/shopMgm',
      name: 'shopMgm',
      component: shopMgm,
      meta: {
        title: "店铺管理-小迪客服助手"
      },
    },
    {
      path: '/replyPolicy',
      name: 'replyPolicy',
      component: replyPolicy,
      meta: {
        title: "回复策略-小迪客服助手"
      },
    },
    {
      path: '/kamiList',
      name: 'kamiList',
      component: kamiList,
      meta: {
        title: "卡密列表-小迪客服助手"
      },
    }, {
      path: '/exam',
      name: 'exam',
      component: exam,
      meta: {
        title: "考试管理-小迪客服助手"
      },
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      meta: {
        title: "用户管理-小迪客服助手"
      },
    },
    ]
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js